import * as React from "react"
import styled, { css } from "styled-components"

import FunctionLink from "~/components/atoms/FunctionLink"
import Pc from "~/components/atoms/Pc"
import SnsButton from "~/components/atoms/SnsButton"
import Sp from "~/components/atoms/Sp"
import { Color, IsMobile, LineHeight, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  open: boolean
  lineQrImageUrl: string
  close: Function
  addFriend: () => void
}

interface StyledProps {
  open?: boolean
  selected?: boolean
}

const CourseApplyDoneModal = ({ open, close, addFriend, lineQrImageUrl }: Props) => {
  return (
    <>
      <StyledDialogWrapper open={open}>
        <StyledDialogHeading className="gtm_course-complete-apply-modal">
          個別相談会への申込みが完了しました
          {/* <br />
          <span className="sp-hide">QRコードから</span>
          公式LINEを友達追加し、氏名をお送りください */}
        </StyledDialogHeading>
        <StyledDialogContent>
          <StyledDescription>
            日程確定のご連絡はLINEを通じて行います。
            <br />
            <span className="attention">
              必ず公式LINEを友達追加し、申込者の判別のためメッセージで氏名をお送りください。
            </span>
          </StyledDescription>
          <Pc>
            <StyledQrWrapper>
              <img src={lineQrImageUrl} className="qr-img" />
            </StyledQrWrapper>
          </Pc>
        </StyledDialogContent>
        <StyledActionPairButtonWrapper>
          <Sp>
            <SnsButton size="Medium" snsType="Line" onClick={addFriend}>
              友達追加する
            </SnsButton>
          </Sp>
          <FunctionLink size="Medium" onClick={close} className="close">
            閉じる
          </FunctionLink>
        </StyledActionPairButtonWrapper>
      </StyledDialogWrapper>
      <StyledDialogOverlay open={open} />
    </>
  )
}

const StyledDialogWrapper = styled.div`
  width: calc(100% - 32px);
  max-width: 400px;
  margin: auto;
  padding: ${SpacingSize.XL}px;
  display: none;
  position: fixed;
  top: ${SpacingSize["3XL"]}px;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

const StyledDialogOverlay = styled.div`
  position: fixed;
  z-index: 99;
  top: -25%;
  left: 0;
  bottom: 0;
  right: 0;
  height: 125%;
  width: 100%;
  background: #000;
  display: none;
  opacity: 0.6;
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

const StyledDialogHeading = styled.div`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.L}px;
  font-weight: bold;
  line-height: ${LineHeight.S}%;
  .sp-hide {
    ${IsMobile(css`
      display: none;
    `)}
  }
`

const StyledDialogContent = styled.div`
  margin-bottom: ${SpacingSize.M}px;
  font-size: ${TextSize.S}px;
  line-height: ${LineHeight.M}%;
`

const StyledDescription = styled.div`
  margin-bottom: ${SpacingSize.M}px;
  font-size: ${TextSize.S}px;
  line-height: ${LineHeight.M}%;
  color: ${Color.Gray};
  .attention {
    font-weight: bold;
    color: ${Color.Attention};
  }
`

const StyledQrWrapper = styled.div`
  display: flex;
  justify-content: center;
  .qr-img {
    width: 180px;
  }
`

const StyledActionPairButtonWrapper = styled.div`
  max-width: 320px;
  margin: auto;
  ${IsMobile(css`
    max-width: 280px;
  `)}
  .close {
    text-align: center;
    padding: ${SpacingSize.M}px 0;
  }
`

export default CourseApplyDoneModal
